export default "__VITE_ASSET__CSlkhK4P__"